var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('table-component',{attrs:{"section":'user',"detail-url":'userDetail',"columns":_vm.columns},on:{"switchUser":_vm.confirmSwitch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }